export enum eRecordingFees {
  deed = 'deed',
  mortgage = 'mortgage',
  assignment = 'assignment',
  cema = 'cema',
  lien_release = 'lien_release',
  memorandum = 'memorandum',
  mortgage_tax_affidavit = 'mortgage_tax_affidavit',
  notice_of_settlement = 'notice_of_settlement',
  power_of_attorney = 'power_of_attorney',
  subordination_agreement = 'subordination_agreement',
  ucc_3 = 'ucc_3',
}

export const prettyRecordingFee: Record<eRecordingFees, string> = {
  [eRecordingFees.deed]: 'Deed',
  [eRecordingFees.mortgage]: 'Mortgage',
  [eRecordingFees.assignment]: 'Assignment',
  [eRecordingFees.cema]: 'CEMA',
  [eRecordingFees.lien_release]: 'Lien Release',
  [eRecordingFees.memorandum]: 'Memorandum',
  [eRecordingFees.mortgage_tax_affidavit]: 'Mortgage Tax Affidavit',
  [eRecordingFees.notice_of_settlement]: 'Notice of Settlement',
  [eRecordingFees.power_of_attorney]: 'Power of Attorney',
  [eRecordingFees.subordination_agreement]: 'Subordination Agreement',
  [eRecordingFees.ucc_3]: 'UCC 3',
};
